import { FiTaskPriorityType } from '@fi-app/task-v2/fi-task-v2-enums';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-task-v2-priority-badge',
    templateUrl: './fi-task-v2-priority-badge.component.html',
    styleUrls: ['./fi-task-v2-priority-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: { class: 'fi-task-v2-priority-badge' },
})
export class FiTaskV2PriorityBadgeComponent {
    @Input({ required: true }) priority: FiTaskPriorityType;
    @Input() shortLabel = false;

    private readonly taskPriorityLabels = {
        [FiTaskPriorityType.Low]: 'task.priority_low',
        [FiTaskPriorityType.Medium]: 'task.priority_medium',
        [FiTaskPriorityType.High]: 'task.priority_high',
    } as const;

    private readonly taskPriorityShortLabels = {
        [FiTaskPriorityType.Low]: 'common.low',
        [FiTaskPriorityType.Medium]: 'common.medium',
        [FiTaskPriorityType.High]: 'common.high',
    } as const;

    private readonly taskPriorityClasses = {
        [FiTaskPriorityType.Low]: 'fi-task-v2-priority-badge--low',
        [FiTaskPriorityType.Medium]: 'fi-task-v2-priority-badge--medium',
        [FiTaskPriorityType.High]: 'fi-task-v2-priority-badge--high',
    } as const;

    protected getPriorityTextId(): string {
        return this.shortLabel
            ? this.taskPriorityShortLabels[this.priority] || ''
            : this.taskPriorityLabels[this.priority] || '';
    }

    protected getPriorityClass(): string {
        return this.taskPriorityClasses[this.priority] || '';
    }
}
